export default __webpack_public_path__ + "static/media/paymentTutorial_mobile_bottom_En.72f9b934.webp";